
<script>
    import PreviewComponent from "./PreviewComponent";    
    import PaymentMethodComponent from '../../components/pagesbuilder/dynamic-components/PaymentMethodComponent';
    

    export default {
        name: "PreviewPaymentMethodComponent",
        mixins: [PreviewComponent, PaymentMethodComponent],

        computed: {
            isAuthoring(){
                return false;
            },    
        },
        
        methods:{
                        
        }
    }
</script>
